import UserConsent from "./userConsent";

document.addEventListener('DOMContentLoaded', () => {
    const userConsentModal = document.querySelector('#userConsentModal');
    const manageConsentUser = document.querySelector('#manageConsentUser');
    const continueWithoutAccepting = document.querySelector('#userConsentModal #continueWithoutAccepting');
    const acceptCookies = document.querySelector('#userConsentModal #acceptCookies');
    const cookiePreferences = document.querySelector('#userConsentModal #cookiePreferences');
    const cookieSettings = document.querySelector('#userConsentModal #cookieSettings');
    const saveAndContinue = document.querySelector('#userConsentModal #saveAndContinue');


    const isModalVisible = () => userConsentModal?.style.display === 'block' ?? false;

    let cookie_consent = 0;

    const userConsent = new UserConsent();
    userConsent.init();

    if (manageConsentUser === null) {
        return;
    }
    manageConsentUser.addEventListener("click", () => {
        $('#userConsentModal').modal({
            show: true,
            backdrop: 'static',
            keyboard: false
        });
    });

    acceptCookies.addEventListener("click", () => {
        cookie_consent = 1;
        userConsent.userConsentSave(cookie_consent, isModalVisible());
    });
    saveAndContinue.addEventListener("click", () => {
        cookie_consent = 1;
        userConsent.userConsentSave(cookie_consent, isModalVisible());
    });

    function acceptOrNotDomEvent(btn1, btn2) {
        btn1.classList.remove('btn-stroke');
        btn1.classList.add('btn-primary');
        btn2.classList.remove('btn-primary');
        btn2.classList.add('btn-stroke');
        btn2.blur();
        btn1.blur();
    }
});
